module.exports = __webpack_public_path__ + "img/4_95.cdbf58c8.png";